import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionResponseEventMutation, deleteQuestionResponseEventMutationVariables } from '../generated/deleteQuestionResponseEventMutation';
import { questionResponseEventFieldsFragment } from '../models/QuestionResponseEvent';

/**
 * Get a callback to delete a QuestionResponseEvent in the store.
 */
export function useDeleteQuestionResponseEventCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionResponseEventMutation, deleteQuestionResponseEventMutationVariables>(
        gql`
            mutation deleteQuestionResponseEventMutation ($id: ID!) {
                deleteQuestionResponseEvent(id: $id) {
                    ...questionResponseEventFields
                }
            }

            ${questionResponseEventFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
